// Comp/Step1ClientDetails.jsx
import React, { useState, useRef } from "react";
import Classes from "../AddClient.module.css";

export default function Step1ClientDetails({
  draft, setClient, addDocuments, removeDocument, next, isEdit = false,
}) {
  const c = draft.client;
  const [err, setErr] = useState("");
  const fileRef = useRef(null);
  const [dragging, setDragging] = useState(false);

  const onChange = (e) => {
    const { name, value } = e.target;
    setClient({ [name]: value });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (!c.firstName || !c.lastName || !c.email || !c.phone || !c.address1 || !c.city || !c.region || !c.postalCode || !c.country) {
      return setErr("Please fill in all required fields including Country.");
    }
    if (!isEdit && !c.password) {
      return setErr("Password is required when creating a client.");
    }
    setErr("");
    next();
  };

  const onDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    addDocuments(e.dataTransfer.files);
  };

  return (
    <form className={Classes.infoCon} onSubmit={onSubmit}>
      <div className={Classes.infoConMiddle}>
        <h3 style={{ marginBottom: 20 }}>{isEdit ? "Edit Client" : "Client Details"}</h3>

        {/* Names */}
        <div className={Classes.flexColGroup}>
          <div className={Classes.flexCol1}>
            <h5 className={Classes.label}>First Name</h5>
            <input className={Classes.inputField} name="firstName" value={c.firstName} onChange={onChange} placeholder="First Name" required />
          </div>
          <div className={Classes.flexCol1}>
            <h5 className={Classes.label}>Last Name</h5>
            <input className={Classes.inputField} name="lastName" value={c.lastName} onChange={onChange} placeholder="Last Name" required />
          </div>
        </div>

        {/* Email / Phone */}
        <div className={Classes.flexColGroup}>
          <div className={Classes.flexCol1}>
            <h5 className={Classes.label}>Email</h5>
            <input type="email" className={Classes.inputField} name="email" value={c.email} onChange={onChange} placeholder="email@domain.com" required />
          </div>
          <div className={Classes.flexCol1}>
            <h5 className={Classes.label}>Phone</h5>
            <input className={Classes.inputField} name="phone" value={c.phone} onChange={onChange} placeholder="+1 555 555 5555" required />
          </div>
        </div>

        {/* Password (create only) */}
        {!isEdit && (
          <div className={Classes.flexColGroup}>
            <div className={Classes.flexCol1}>
              <h5 className={Classes.label}>Password</h5>
              <input type="password" className={Classes.inputField} name="password" value={c.password || ""} onChange={onChange} placeholder="••••••••" required />
            </div>
          </div>
        )}

        {/* Address / City */}
        <div className={Classes.flexColGroup}>
          <div className={Classes.flexCol1}>
            <h5 className={Classes.label}>Address</h5>
            <input className={Classes.inputField} name="address1" value={c.address1} onChange={onChange} placeholder="Street address" required />
          </div>
          <div className={Classes.flexCol1}>
            <h5 className={Classes.label}>City</h5>
            <input className={Classes.inputField} name="city" value={c.city} onChange={onChange} placeholder="City" required />
          </div>
        </div>

        {/* Region / Postal */}
        <div className={Classes.flexColGroup}>
          <div className={Classes.flexCol1}>
            <h5 className={Classes.label}>State / Province / Region</h5>
            <input className={Classes.inputField} name="region" value={c.region} onChange={onChange} placeholder="State / Province / Region" required />
          </div>
          <div className={Classes.flexCol1}>
            <h5 className={Classes.label}>Postal / Zip Code</h5>
            <input className={Classes.inputField} name="postalCode" value={c.postalCode} onChange={onChange} placeholder="Zip" required />
          </div>
        </div>

        {/* Country */}
        <div className={Classes.flexColGroup}>
          <div className={Classes.flexCol1}>
            <h5 className={Classes.label}>Country</h5>
            <input className={Classes.inputField} name="country" value={c.country} onChange={onChange} placeholder="Country" required />
          </div>
        </div>

        {/* Neighborhood / Company */}
        <div className={Classes.flexColGroup}>
          <div className={Classes.flexCol1}>
            <div className={Classes.flexAlign10}><h5 className={Classes.label}>Neighborhood</h5><div className={Classes.optionalText}><h5>Optional</h5></div></div>
            <input className={Classes.inputField} name="neighborhood" value={c.neighborhood} onChange={onChange} placeholder="Neighborhood (Optional)" />
          </div>
          <div className={Classes.flexCol1}>
            <div className={Classes.flexAlign10}><h5 className={Classes.label}>Company</h5><div className={Classes.optionalText}><h5>Optional</h5></div></div>
            <input className={Classes.inputField} name="company" value={c.company} onChange={onChange} placeholder="Company (Optional)" />
          </div>
        </div>

        {/* Gate Code / Parking Spot */}
        <div className={Classes.flexColGroup}>
          <div className={Classes.flexCol1}>
            <div className={Classes.flexAlign10}><h5 className={Classes.label}>Gate Code/Access Instructions</h5><div className={Classes.optionalText}><h5>Optional</h5></div></div>
            <input className={Classes.inputField} name="gateCode" value={c.gateCode} onChange={onChange} placeholder="e.g. Gate code, guard name, etc." />
          </div>
          <div className={Classes.flexCol1}>
            <div className={Classes.flexAlign10}><h5 className={Classes.label}>Parking Spot #</h5><div className={Classes.optionalText}><h5>Optional</h5></div></div>
            <input className={Classes.inputField} name="parkingSpot" value={c.parkingSpot} onChange={onChange} placeholder="Spot / landmark / notes" />
          </div>
        </div>

        {/* Documents (new uploads only) */}
        <div className={Classes.flexColGroup}>
          <div className={Classes.flexCol1}>
            <div className={Classes.flexAlign10}><h5 className={Classes.label}>Upload Client Documents</h5><div className={Classes.optionalText}><h5>Optional</h5></div></div>
            <div
              className={`${Classes.fileUpload} ${dragging ? "dragActive" : ""}`}
              onDragOver={(e) => { e.preventDefault(); setDragging(true); }}
              onDragLeave={() => setDragging(false)}
              onDrop={onDrop}
              onClick={() => document.getElementById("fileInput-hidden")?.click()}
            >
              <input id="fileInput-hidden" type="file" multiple hidden onChange={(e) => addDocuments(e.target.files)} />
              <h5><span>Browse</span> or drag and drop</h5>
            </div>

            {c.documents?.length > 0 && (
              <ul className={Classes.fileList}>
                {c.documents.map((f, i) => (
                  <li key={i}>
                    <span style={{ fontSize: 13, fontWeight: 600 }}>{f.name}</span>
                    <button type="button" className={Classes.removeBtn} onClick={() => removeDocument(i)}>Remove</button>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>

        {err && <p style={{ color: "#b00020", fontSize: 12 }}>{err}</p>}
      </div>

      <div className={Classes.navRow}>
        <button type="button" className={Classes.backBtn} disabled><h5>Back</h5></button>
        <button type="submit" className={Classes.saveBtn}><h5>Next</h5></button>
      </div>
    </form>
  );
}
